import type { PageContext } from 'vike/types';

export default function title(pageContext: PageContext): string {
  return (pageContext as any).data?.metaTitle ?? 'Salary Data in Finland | JobCrawls';
}
